import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

// Merge conditional class lists and resolve Tailwind conflicts (last one wins).
export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
